<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="container">
    <v-card class="card" color="transparent" elevation="0">
      <div class="logo">
        <v-img class="img-logo" :src="require('@/assets/xtium_white_x_mark.svg')" max-height="60" max-width="60" />
      </div>
      <div>
        <v-card-title>
          <div class="xtium-title">{{ $t('title') }}</div>
        </v-card-title>
        <v-card-text>
          <div class="xtium-subtitle">{{ $t('message') }}</div>
        </v-card-text>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'EcsLogin'
};
</script>

<style scoped>
.container {
  display: grid;
  height: 100vh;
  width: 100vw;
  max-width: none !important;
  background: linear-gradient(90deg, #001718 25%, #034c57 100%);
  align-content: center;
}

.card {
  padding: 0;
  display: grid;
  width: 600px;
  grid-template-columns: 68px auto 68px;
  margin: 0 auto;
}

.card .logo {
  margin: 22px 0 0 0;
}

.v-card__title {
  padding: 12px 0 8px 20px;
}

.v-card__text {
  padding: 12px 0 8px 20px;
}
</style>
